import { getAlbumPrintPackageTaggedItem } from '../../../../apps/pro/views/HierarchyItem/Matches/components/PurchasingOptions/helpers';

/**
 * Returns whether an AlbumPrintPackageCartItem should render an upsell for the Tagged
 * Photo promo.
 *
 * @param {Object} cartItem The AlbumPrintPackageCartItem.
 * @returns {undefined|boolean}
 */
export const albumPrintPackageCartItemRendersTagUpsell = cartItem => {
  const overriddenPrintPackageItem = getAlbumPrintPackageTaggedItem(
    cartItem.albumPrintPackage,
  );
  const extendedPrintPackageItem = cartItem.extendedPrintPackageItems?.find(
    item =>
      !!item.photo &&
      item.printPackageItem.id === overriddenPrintPackageItem.id,
  );

  return overriddenPrintPackageItem && !extendedPrintPackageItem;
};

/**
 * Returns the appropriate upsell price for a photo, either the tag based
 * price, or the print package specific price.
 *
 * @param {Object} cartItem The AlbumPrintPackageCartItem.
 * @returns {Number}
 */
export const getAlbumPrintPackageCartItemUpsellPrice = cartItem => {
  const { photo, albumPrintPackage } = cartItem;
  const { print_package: printPackage } = albumPrintPackage ?? {};

  const pricedTag = photo?.price_album_folder_tag;

  if (
    pricedTag?.digital_downloads_price?.value >
    printPackage.digital_downloads_upsell_price?.value
  ) {
    return pricedTag?.digital_downloads_price?.value;
  }

  return printPackage.digital_downloads_upsell_price?.value;
};
